import { useState } from 'react';

import { CoreIcon } from '../icon';

const SHOW_LABEL = 'Show password';
const HIDE_LABEL = 'Hide password';

export const usePasswordField = (type: string) => {
  const [showPassword, setShowPassword] = useState(false);

  const isPasswordField = type === 'password';
  const effectiveType = isPasswordField && showPassword ? 'text' : type;

  const toggle = () => setShowPassword((prev) => !prev);

  const passwordIcon = isPasswordField ? (
    <CoreIcon
      name={
        showPassword ? 'icon-view-visibility-off' : 'icon-view-visibility-on'
      }
      ariaHidden
    />
  ) : null;

  const passwordAriaLabel = showPassword ? HIDE_LABEL : SHOW_LABEL;

  return {
    isPasswordField,
    effectiveType,
    passwordIcon,
    passwordAriaLabel,
    toggle,
  };
};
